<template>
    <div class="relative">
      


        <div class="absolute top-0 left-0 w-full h-full">
            <nuxt-img :src="heroImageSrc" sizes="xs:340px sm:450ppx md:766px lg:1023px xl:1200px" preload fetchpriority="high" loading="eager" width="1920" height="1157" :alt="heroImageAlt" format="webp" class="object-cover w-full h-full" />
        </div>

        <div class="relative z-10">

          <div
            class="flex top-0 z-20 flex-wrap gap-x-2 gap-y-2 justify-between items-center px-3 pt-4 mx-auto w-full max-w-screen-2xl lg:px-8 sm:px-6">
            <!-- Logo -->
            <div class="relative">
                <a href="/">
                    <nuxt-img :src="logoSrc" :alt="logoAlt" width="167" height="64"
                        class="object-contain relative z-10 w-28 md:w-40" />
                </a>

            </div>
            <!-- Header actions -->
            <div class="flex z-20 gap-2 items-center sm:gap-4 lg:gap-x-8">
                <!-- Phone number - hidden on mobile -->
                <a :href="`tel:${phoneNumber}`"
                    class="hidden gap-2 items-center px-4 py-2 text-base text-white rounded-full transition sm:flex sm:py-2.5">

                    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.1172 3.91016C17.4417 4.26563 18.6494 4.96323 19.6191 5.93295C20.5889 6.90267 21.2865 8.11039 21.6419 9.43491" stroke="white" stroke-width="1.56177" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.3047 6.92578C16.1013 7.13735 16.8278 7.55574 17.4107 8.13856C17.9935 8.72139 18.4119 9.44792 18.6234 10.2445" stroke="white" stroke-width="1.56177" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.58549 12.1876C10.389 13.847 11.7308 15.1854 13.3923 15.9846C13.5149 16.0427 13.6504 16.0678 13.7856 16.0575C13.9208 16.0473 14.051 16.002 14.1634 15.9261L16.6037 14.296C16.7115 14.2229 16.8361 14.1782 16.9658 14.1663C17.0955 14.1543 17.2262 14.1755 17.3455 14.2277L21.9137 16.1896C22.0698 16.2546 22.2003 16.3691 22.2849 16.5155C22.3696 16.6619 22.4038 16.8321 22.3822 16.9998C22.2374 18.1299 21.6858 19.1685 20.8306 19.9213C19.9755 20.674 18.8753 21.0894 17.736 21.0897C14.2152 21.0897 10.8387 19.6911 8.3491 17.2015C5.85955 14.712 4.46094 11.3354 4.46094 7.81465C4.46119 6.67534 4.87658 5.57516 5.62936 4.71997C6.38214 3.86478 7.42074 3.31318 8.55082 3.16839C8.71855 3.14685 8.88871 3.18104 9.03511 3.2657C9.1815 3.35036 9.296 3.4808 9.36098 3.63692L11.323 8.21486C11.374 8.33233 11.3953 8.46055 11.3851 8.58821C11.3749 8.71588 11.3334 8.83907 11.2644 8.94693L9.63429 11.4262C9.56172 11.5384 9.51913 11.6673 9.51058 11.8006C9.50204 11.9339 9.52783 12.0671 9.58549 12.1876Z" stroke="white" stroke-width="1.56177" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


                 
                    <span class="contents"><span class="hidden md:block">{{ phoneText }}</span>
                        {{ phoneNumber }}</span></a>
                <!-- Add to cart button -->
                <button @click="scrollTo(buttonHref)"
                    class="flex items-center px-4 py-2 mx-auto text-base rounded-full lg:px-8 font-ww-medium btn-red gap-x-2 sm:px-6 sm:py-3 hover:bg-[#f3695e] transition-colors duration-200">{{ buttonText }}</button>
            </div>
        </div>

            <div class="absolute top-0 left-0 w-full h-full bg-black opacity-30 md:hidden">

            </div>
            
          <div class="relative z-10 px-4 pt-6 mx-auto xl:px-0 xl:pt-10 md:pt-10" :class="smallText ? 'xl:max-w-7xl max-w-6xl' : 'max-w-5xl'">
            <h2 class="leading-none text-center text-white font-ww-medium" v-html="subHeading" :class="smallText ? 'xl:text-4xl md:text-3xl text-balance text-xl' : 'text-2xl md:text-4xl xl:text-42 '">
            </h2>

            <h1 class="text-center font-ww-medium font-bold text-[#C4E538] py-2" :class="smallText ? 'text-3xl md:text-5xl xl:text-6xl text-balance sm-max:leading-8' : 'text-4xl md:text-6xl xl:text-7xl'" v-html="mainHeading">
            </h1>

            <div class="mt-2 leading-none text-center text-white font-ww-medium" :class="smallText ? 'md:text-2xl xl:text-3xl text-lg text-balance' : 'md:text-4xl xl:text-42 text-2xl'" v-html="tagline">
            </div>

            <div v-if="showDescriptionText" class="'max-w-2xl mx-auto mt-6 text-lg text-left text-white md:text-center lg:max-w-4xl xl:max-w-6xl xl:px-0 2xl:px-20 xl:text-2xl font-ww-bold drop-shadow-lg'" v-html="descriptionText">
            </div>
          </div>

            <div class="relative z-10 mt-8">
                <nuxt-img :src="productImageSrc" width="2000" height="800"
                    :alt="productImageAlt" sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw 3xl:100vw 4xl:100vw" format="webp" preload fetchpriority="high" loading="eager" class="hidden mx-auto w-full md:block" />

                    <nuxt-img :src="productImageMobileSrc" width="750" height="800"
                    :alt="productImageMobileAlt" sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw 3xl:100vw 4xl:100vw" format="webp" preload fetchpriority="high" loading="eager" class="block mx-auto w-full md:hidden" />
            </div>
            <!-- <div class="absolute -bottom-6 z-10 mx-auto w-full md:bottom-6">
            <button @click="scrollTo(buttonHref)"
            class="flex gap-x-2 items-center px-12 py-3 mx-auto text-base rounded-full transition-colors duration-200 md:text-xl md:px-24 lg:py-4 font-ww-medium btn-red">{{ buttonText }}</button>
          </div> -->

        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  logoSrc: {
    type: String,
    default: '/assets/images/horizontal-logo.png',
  },
  logoAlt: {
    type: String,
    default: 'Decaf Coffee',
  },
  phoneNumber: {
    type: String,
    default: '1-800-479-1596',
  },
  phoneText: {
    type: String,
    default: 'Call Us Toll Free:',
  },
  buttonText: {
    type: String,
    default: 'Add To Cart',
  },
  buttonHref: {
    type: String,
    default: 'products',
  },
  heroImageSrc: {
    type: String,
    default: '/assets/images/decaf-hero.jpg',
  },
  heroImageAlt: {
    type: String,
    default: 'Decaf Coffee',
  },
  subHeading: {
    type: String,
    default: 'USDA Organic Coffee 99.9% Decaffeinated',
  },
  mainHeading: {
    type: String,
    default: 'Without Harmful Chemicals',
  },
  tagline: {
    type: String,
    default: 'That\'s Gut-Friendly and Tastes Delicious',
  },
  descriptionText: {
    type: String,
    default: 'Discover Why 444,270 Americans Have Switched to this Stomach-Friendly, Full Flavor Decaf Coffee',
  },
  productImageSrc: {
    type: String,
    default: '/assets/images/decaf-head-new.png',
  },
  productImageAlt: {
    type: String,
    default: 'Decaf Coffee',
  },
  productImageMobileSrc: {
    type: String,
    default: '/assets/images/decaf-head-new-mobile.png',
  },
  productImageMobileAlt: {
    type: String,
    default: 'Decaf Coffee',
  },
  showDescriptionText: {
    type: Boolean,
    default: true,
  },
  smallText: {
    type: Boolean,
    default: false,
  },
});

defineBuilderComponent({
  friendlyName: 'ProductHeadline',
  inputs: [
    {
      name: 'logoSrc',
      type: 'file',
      friendlyName: 'Logo Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/horizontal-logo.png',
    },
    {
      name: 'logoAlt',
      type: 'text',
      friendlyName: 'Logo Alt Text',
      defaultValue: 'Decaf Coffee',
    },
    {
      name: 'phoneNumber',
      type: 'text',
      friendlyName: 'Phone Number',
      defaultValue: '1-800-479-1596',
    },
    {
      name: 'phoneText',
      type: 'text',
      friendlyName: 'Phone Label Text',
      defaultValue: 'Call Us Toll Free:',
    },
    {
      name: 'buttonText',
      type: 'text',
      friendlyName: 'Button Text',
      defaultValue: 'Get Discount',
    },
    {
      name: 'buttonHref',
      type: 'text',
      friendlyName: 'Button Link',
      defaultValue: 'products',
    },
    {
      name: 'heroImageSrc',
      type: 'file',
      friendlyName: 'Hero Background Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/decaf-hero.jpg',
    },
    {
      name: 'heroImageAlt',
      type: 'text',
      friendlyName: 'Hero Image Alt Text',
      defaultValue: 'Decaf Coffee',
    },
    {
      name: 'subHeading',
      type: 'richText',
      friendlyName: 'Sub Heading',
      defaultValue: 'USDA Organic Coffee 99.9% Decaffeinated',
    },
    {
      name: 'mainHeading',
      type: 'richText',
      friendlyName: 'Main Heading',
      defaultValue: 'Without Harmful Chemicals',
    },
    {
      name: 'tagline',
      type: 'richText',
      friendlyName: 'Tagline',
      defaultValue: 'That\'s Gut-Friendly and Tastes Delicious',
    },
    {
      name: 'descriptionText',
      type: 'richText',
      friendlyName: 'Description Text',
      defaultValue: 'Discover Why 444,270 Americans Have Switched to this Stomach-Friendly, Full Flavor Decaf Coffee',
    },
    {
      name: 'productImageSrc',
      type: 'file',
      friendlyName: 'Product Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/decaf-head-new.png',
    },
    {
      name: 'productImageAlt',
      type: 'text',
      friendlyName: 'Product Image Alt Text',
      defaultValue: 'Decaf Coffee',
    },
    {
      name: 'productImageMobileSrc',
      type: 'file',
      friendlyName: 'Product Mobile Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/decaf-head-new-mobile.png',
    },
    {
      name: 'productImageMobileAlt',
      type: 'text',
      friendlyName: 'Product Mobile Image Alt Text',
      defaultValue: 'Decaf Coffee',
    },
    {
      name: 'showDescriptionText',
      type: 'boolean',
      friendlyName: 'Show Description Text',
      defaultValue: true,
    },
    {
      name: 'smallText',
      type: 'boolean',
      friendlyName: 'Small Text',
      defaultValue: false,
    },
  ],
});
</script>